import { render, staticRenderFns } from "./CoursewareAdminViewWidget.vue?vue&type=template&id=05293a90&"
import script from "./CoursewareAdminViewWidget.vue?vue&type=script&lang=js&"
export * from "./CoursewareAdminViewWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports